import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../axiosInstance';

const PaymentReceipt = () => {
    const { id } = useParams(); // Get the ID from the URL
    const navigate = useNavigate();
    const [receipt, setReceipt] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        // Fetch data from the backend using the ID from the URL
        axiosInstance
            .get(`/payment/receipt/${id}`)
            .then((response) => {
                const data = response.data.data;
                setReceipt(data);
                calculateTotal(data.row);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.response?.data?.message || 'An error occurred while fetching data.');
                setLoading(false);
            });
    }, [id]);

    const calculateTotal = (rows) => {
        let sum = 0;
        rows?.forEach((r) => {
            sum += parseFloat(r.amount || 0);
        });
        setTotal(sum.toFixed(2));
    };

    const handlePrint = () => {
        window.print();
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div style={{ margin: '10px' }}>
            <div className="modal-header content">
                {!error ? (
                    <>
                        <div className="modal-body">
                            <h1 style={{ textAlign: 'center',fontWeight: 'bold',paddingBottom:"20px" }}>{receipt?.system_name}</h1>
                            
                            <div id="cntr" className="padded">
                                <table style={{ marginBottom: '10px', width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '40%', fontWeight: 'bold' }}>INVOICE:</td>
                                            <td style={{ width: '60%' }}>{receipt?.session_id}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '40%', fontWeight: 'bold' }}>PATIENT:</td>
                                            <td style={{ width: '60%' }}>{receipt?.detail?.patient_name || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '40%', fontWeight: 'bold' }}>PREPARED BY:</td>
                                            <td style={{ width: '60%' }}>{receipt?.user_name || 'User'}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '40%', fontWeight: 'bold' }}>DATE PREPARED:</td>
                                            <td style={{ width: '60%' }}>{receipt?.detail?.created || '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h4 style={{ textAlign: 'center' }}>ITEMS</h4>
                                <table className="responsive-table w-full">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%', padding:"20px" }}>Date</th>
                                            <th style={{ width: '30%' }}>Payment Option</th>
                                            <th style={{ width: '30%' }}>Received By</th>
                                            <th style={{ width: '20%' }}>Amount Paid</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {receipt?.row?.map((r, index) => (
                                            <tr key={index}>
                                                <td style={{ textAlign: 'center' }}>{r.created || '-'}</td>
                                                <td style={{ textAlign: 'center' }}>{r.pay_option || '-'}</td>
                                                <td style={{ textAlign: 'center' }}>{r.received_by_name || '-'}</td>
                                                <td style={{ textAlign: 'center' }}>{r.amount || '-'}</td>
                                            </tr>
                                        ))}
                                        <br/>
                                        <tr >
                                            <td colSpan={2}></td>
                                            <td style={{ textAlign: 'center' }}>
                                                <strong>Total:</strong>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <strong>{total}</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table style={{ marginTop: '20px', width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '80%', fontWeight: 'bold', textAlign: 'right' }}>
                                                TOTAL:
                                            </td>
                                            <td style={{ width: '20%', textAlign: 'right', fontWeight: 'bold' }}>
                                                {total}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button onClick={() => navigate(-1)} className='mr-5 mt-5'>Back</button>
                            <button onClick={handlePrint}>Print</button>
                        </div>
                    </>
                ) : (
                    <p>{error}</p>
                )}
            </div>
        </div>
    );
};

export default PaymentReceipt;
